import values from 'lodash/values';
import includes from 'lodash/includes';

import { VisitReason } from '@jerry-serverless/enums/visit_reason';

export { VisitReason };

/**
 * Check if string value is in enum.
 *
 * @param val
 */
export const isVisitReason = (val?: string | null): val is VisitReason => {
  return includes(values(VisitReason), val);
};

export const VISIT_REASON_TITLE: Readonly<{ [reason in VisitReason]: string }> = {
  [VisitReason.BETTER_RATE]: 'I want a better rate',
  [VisitReason.NEW_CAR]: 'I just bought a new car',
  [VisitReason.SHOPPING_AROUND]: 'Just shopping around',
};

export const VISIT_REASONS = [VisitReason.BETTER_RATE, VisitReason.NEW_CAR, VisitReason.SHOPPING_AROUND];
